import { Alert } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ServerValidationStatus } from '../utils/validationStatusEnum';

export interface UrlAlertProps {
  validationStatus: string;
}

export const UrlAlert = ({ validationStatus }: UrlAlertProps) => {
  const [t] = useTranslation('geosecma-settings');

  switch (validationStatus) {
    case ServerValidationStatus.valid:
      return <Alert data-testid="urlAlertValid" message={t('validSource')} type="success" showIcon />;
    case ServerValidationStatus.invalidServer:
      return <Alert data-testid="urlAlertInvalidServer" message={t('invalidSourceError')} type="error" showIcon />;
    case ServerValidationStatus.notValidated:
      return <Alert data-testid="urlAlertNotValidated" message={t('validateSourceWarning')} type="warning" showIcon />;
    case ServerValidationStatus.unauthorized:
      return <Alert data-testid="urlAlertUnauthorized" message={t('unauthorizedError')} type="error" showIcon />;
    case ServerValidationStatus.invalidCredentials:
      return (
        <Alert data-testid="urlAlertInvalidCredentials" message={t('invalidCredentialsError')} type="error" showIcon />
      );
    default:
      return null;
  }
};
